<style>
.echarts {
  width: 100%;
  height: 100%;
}

.active_table {
  width: 100%;
  height: 100%;
}

.ch {
  width: 80vw;
  height: 80vh;
  margin: 0 auto;
}
</style>

<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <router-link to="/waste/statisticsSolid">
          <i-button type="info" style="margin-left: 1em;">一般固废统计</i-button>
        </router-link>
        <router-link to="/waste/statistics">
          <i-button type="info" style="margin-left: 1em;">危废统计</i-button>
        </router-link>
      </div>
    </toolbar>
    <div class="ch">
      <div>
        <h1>库存统计</h1>
      </div>
      <div>
        <v-chart autoresize :options="orgOptions" style="height: 60vh" />
      </div>
      <p></p>
    </div>
  </div>
</template>
 
<script>
import toolbar from "../toolBar.vue"; // 操作栏组件

export default {
  data() {
    return {
      orgOptions: {},
      // 查询
      search: {
        startDate: null,
        endDate: null,
      },
      allData: []
    };
  },
  components: {
    toolbar
  },
  created: function () {
    this.getData();
  },
  methods: {
    getData() {
      var that = this;
      // 获取数据
      this.$api.Waste.getWasteSolidStatistics({ content: this.search }, [
        "uuid",
        "company",
      ]).then((res) => {
        if (res.code == 0) {
          // 获取成功
          this.allData = res.data; //数据
          let dateList = []; // 标题
          let dataList = []; // 数据值
          this.allData.map((res) => {
            dateList.push(res.wasteName);
            dataList.push(res.totalWeight);
          });

          this.orgOptions = {
            color: ["#3398DB"],
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                const count = that.findCountByWasteName(params[0].name);
                let res = params[0].name +
                  "<br/>共:" + count + "件" +
                  "<br/>合计:" + (params[0].value) + "吨";
                return res;
              },
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
              textStyle: {
                color: '#FFF', // 文本颜色
                fontSize: 14, // 文本字体大小
                fontWeight: 'bold', // 文本字体粗细
                align: 'left', // 文本左对齐
              },
            },
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {},
              },
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                name: "危废类型",
                boundaryGap: true,
                axisLabel: {
                  //底部文字倾斜
                  interval: 0,
                  rotate: 25,
                },
                data: dateList,
              },
            ],
            yAxis: [
              {
                type: "value",
              },
            ],
            series: [
              {
                name: "库存危废重量",
                type: "bar",
                barWidth: "60%",
                data: dataList,
              },
            ],
          };
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
        }
      });
    },
    // 选择时间
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours("0");
      this.search.endDate = new Date(date[1]).setHours("24");
      //console.log(this.search);
    },
    findCountByWasteName(wasteName) {
      let data = this.allData;
      for (let i = 0; i < data.length; i++) {
        if (data[i].wasteName === wasteName) {
          return data[i].count;
        }
      }
      return 0;
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
  },
};
</script>